module.exports = __webpack_public_path__ + "img/4.0d882d3b.jpg";